import { ONEC_KIND } from '../features/connection-form/model/settings'
import { ONEC_CREATE_DEFAULTS_WINDOWS } from '../features/create-defaults/windows'
import { ONEC_IMPORT_WINDOWS } from '../features/import/windows'
import { ONEC_INVENTORY_WINDOWS } from '../features/inventory/windows'
import { ONEC_PRICE_TAG_WINDOWS } from '../features/price-tags/windows'
import { ONEC_PRICING_WINDOWS } from '../features/pricing/windows'
import { ONEC_RECEIPT_WINDOWS } from '../features/receipts/windows'
import { ONEC_SHIFT_WINDOWS } from '../features/shifts/windows'
import { ONEC_SOURCE_PURPOSES as PURPOSES } from '../features/source/model/types'
import { ONEC_STRUCTURE_WINDOWS } from '../features/structure/windows'
import { ONEC_SUPPLY_WINDOWS } from '../features/supplies/windows'
import { ONEC_WINDOWS } from './registerWindows'

/**
 * Входы в окна 1С из карточки ресурса Platform (UA1c п. 7): кнопка → окно
 * пакета с rid этой базы. Объект той же формы, что `ResourceEntriesExtension`
 * пакета `platform-ui`: пакеты друг друга не импортируют, совместимость
 * проверяет компилятор при регистрации в `apps/web`. Право — то, без которого
 * окно ничего не покажет; кнопка его только отражает.
 */
export const onecResourceEntries = {
  kind: ONEC_KIND,
  entries: [
    { window: ONEC_WINDOWS.products, label: 'Товары', capability: PURPOSES.products.capability },
    { window: ONEC_SUPPLY_WINDOWS.list, label: 'Поставки', capability: PURPOSES.supplies.capability },
    { window: ONEC_INVENTORY_WINDOWS.inventory, label: 'Инвентаризация', capability: PURPOSES.inventory.capability },
    { window: ONEC_PRICE_TAG_WINDOWS.priceTags, label: 'Ценники', capability: PURPOSES.priceTags.capability },
    { window: ONEC_PRICING_WINDOWS.priceTypes, label: 'Цены', capability: PURPOSES.pricing.capability },
    { window: ONEC_IMPORT_WINDOWS.wizard, label: 'Импорт', capability: PURPOSES.import.capability },
    // Структура — по праву поставок (или инвентаризации на сервере): склады разделов берутся из неё же.
    { window: ONEC_STRUCTURE_WINDOWS.structure, label: 'Структура', capability: PURPOSES.structure.capability },
    { window: ONEC_RECEIPT_WINDOWS.receipts, label: 'Чеки', capability: PURPOSES.receipts.capability },
    { window: ONEC_RECEIPT_WINDOWS.salesStatistics, label: 'Статистика по продажам', capability: PURPOSES.receipts.capability },
    { window: ONEC_SHIFT_WINDOWS.shifts, label: 'Смены', capability: PURPOSES.receipts.capability },
    // RP-SYN11: поля новой карточки из синхронизации; смотреть — по праву чтения каталога, сохранить — служба проверит право записи.
    { window: ONEC_CREATE_DEFAULTS_WINDOWS.createDefaults, label: 'Создание по умолчанию', capability: PURPOSES.products.capability },
  ],
} as const
